const getSelectedQuantityValue = (selectionOptions, selectedQuantity)=>{
    const optionKeys = Object.keys(selectionOptions);
    // If there are no options, then the product is out of stock
    if (!optionKeys.length || !optionKeys[0]) {
        return undefined;
    }
    // Select the first option by default if selectedQuantity is 0
    if (selectedQuantity === 0) {
        return {
            value: optionKeys[0]
        };
    }
    return {
        value: optionKeys[selectedQuantity - 1]
    };
};

export { getSelectedQuantityValue };
//# sourceMappingURL=get-selected-quantity-value.js.map
